import { render, staticRenderFns } from "./PackMenuList.vue?vue&type=template&id=a737191a&scoped=true&"
import script from "./PackMenuList.vue?vue&type=script&lang=js&"
export * from "./PackMenuList.vue?vue&type=script&lang=js&"
import style0 from "./PackMenuList.vue?vue&type=style&index=0&id=a737191a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a737191a",
  null
  
)

export default component.exports